let softExtend = [
  // 付帅云pos
  [
    {
      title: '付帅云收银——A款 微信小程序版本',
      h4: [
        '不用下载，微信小程序，就是你的收银机。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_08.png'
    },
    {
      title: '付帅云收银——B款 支付宝小程序版本',
      h4: [
        '支付宝小程序，也是你的收银机'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_09.png'
    },
    {
      title: '付帅云收银——C款  安卓App版本',
      h4: [
        '可以装在你的手机、平板、收银机，也可以直接用我们的收款收银。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_10.png'
    }
  ],
  // 自助点餐
  [
    {
      title: '付帅点餐宝——A款 微信小程序版本',
      h4: [
        '顾客不用下载，微信扫一扫即可自助点餐'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_07.png'
    },
    {
      title: '付帅点餐宝——B款 支付宝小程序版本',
      h4: [
        '顾客不用下载，支付宝扫一扫即可自助点餐'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_08.png'
    },
  ],
  // 自主外卖
  [
    {
      title: '付帅云店——B款 支付宝小程序版本',
      h4: [
        '客户不用下载，',
        '支付宝，也是你的流量入口。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_08.png'
    },
  ],
  // 扫码购
  [
    {
      title: '付帅扫码购——微信小程序',
      h4: [
        '不用下载，微信小程序，就是你的导购+服务员+收银员！'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_d_07.png'
    }
  ]
]

export default softExtend



// WEBPACK FOOTER //
// ./src/assets/conf/soft_extend.js